 (function () {
  // Don’t do anything inside the Theme Editor sidebar to avoid crashes
  if (window.Shopify && Shopify.designMode) {
    // Still initialize images/links once for the preview pane:
    document.addEventListener('shopify:section:load', init, { once: true });
    document.addEventListener('DOMContentLoaded', init);
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  function init() {
    document.querySelectorAll('.card-wrapper').forEach(setupCard);
  }

  function setupCard(card) {
    // Click a swatch -> mark selected, swap image, update links. No navigation.
    card.addEventListener('click', function (e) {
      const swatch = e.target.closest('.swatch__item');
      if (!swatch || !card.contains(swatch)) return;

      e.preventDefault(); // stay on collection page

      card.querySelectorAll('.swatch__item').forEach(el => el.classList.remove('is-selected'));
      swatch.classList.add('is-selected');

      swapImage(card, {
        src: swatch.dataset.variantSrc,
        srcset: swatch.dataset.variantSrcset,
        sizes: swatch.dataset.variantSizes,
        alt: swatch.dataset.variantAlt
      });

      // Update ALL title links so image/title click goes to the selected variant
      const url = swatch.getAttribute('href');
      if (url) {
        card.querySelectorAll('a.full-unstyled-link,[data-product-url]').forEach(a => {
          if (a.hasAttribute('href')) a.setAttribute('href', url);
          if (a.hasAttribute('data-product-url')) a.setAttribute('data-product-url', url);
        });
      }
    }, { passive: false });

    // On load, align image + links to an existing selected swatch (or the first one)
    const selected = card.querySelector('.swatch__item.is-selected') || card.querySelector('.swatch__item');
    if (selected) {
      selected.classList.add('is-selected');
      swapImage(card, {
        src: selected.dataset.variantSrc,
        srcset: selected.dataset.variantSrcset,
        sizes: selected.dataset.variantSizes,
        alt: selected.dataset.variantAlt
      });
      const url = selected.getAttribute('href');
      if (url) {
        card.querySelectorAll('a.full-unstyled-link,[data-product-url]').forEach(a => {
          if (a.hasAttribute('href')) a.setAttribute('href', url);
          if (a.hasAttribute('data-product-url')) a.setAttribute('data-product-url', url);
        });
      }
    }
  }

  function getPrimaryImg(card) {
    return card.querySelector('.card__media .media img') || card.querySelector('.card__media img');
  }

  function rememberOriginal(card, img) {
    if (card.dataset.origSaved) return;
    card.dataset.origSrc = img.getAttribute('src') || '';
    card.dataset.origSrcset = img.getAttribute('srcset') || '';
    card.dataset.origSizes = img.getAttribute('sizes') || '';
    card.dataset.origAlt = img.getAttribute('alt') || '';
    card.dataset.origSaved = '1';
  }

  function swapImage(card, data) {
    const img = getPrimaryImg(card);
    if (!img) return;
    rememberOriginal(card, img);
    if (data.src) img.setAttribute('src', data.src);
    if (data.srcset) img.setAttribute('srcset', data.srcset);
    if (data.sizes) img.setAttribute('sizes', data.sizes);
    if (data.alt) img.setAttribute('alt', data.alt);
  }
})();



